import React from "react";
import { Add, Footer } from "../components";

const Share = () => {
  return (
    <>
      <Add />
      <Footer />
    </>
  );
};

export default Share;
